import { Component, OnInit } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';

// [anand] if this is shared service consider moving to common folder in proj or lib
import { ReviewOrderService } from './../checkout/review-order/shared/providers/review-order.service'; // need to reverify the logic

import { CartModel } from './../../models';
import { AuthenticationService } from 'lib/ng2-sapmp/src/providers';


@Component({
  selector: 'app-cart',
  templateUrl: './confirm-order.component.html',
  styleUrls: ['./confirm-order.component.scss']
})
export class ConfirmOrderComponent implements OnInit {

  id: string;
  email: string;
  cart: CartModel;

  constructor(private router: Router, private authenticationService: AuthenticationService) {
  }

  ngOnInit() {
    if (JSON.parse(sessionStorage.getItem('order'))) {
      this.id = JSON.parse(sessionStorage.getItem('order')).customerOrderNumber;
    }
    this.cart = JSON.parse(sessionStorage.getItem('cart'));
    if (this.authenticationService.getUser()) {
      this.email = this.authenticationService.getUser().emailAddress;
    }
  }

  onOrderComplete() { // TODO i think this has to happen when placing order.
    this.router.navigate(['browse']);
  }

}









